import React, { MouseEventHandler, useState } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { toast } from 'react-toastify';
import SahamDrawer from 'components/SahamDrawer';
import { translate } from 'containers/services/translate';
import messages from 'containers/CourtManagerLegalProceedings/messages';
import { ContainerInDrawer } from 'containers/LawyerFeeNote/styled-components';
import SahamDialog from 'components/SahamDialog';
import { useDispatch } from 'react-redux';
import VictimForm from 'containers/ProvisionalClaimRecap/Victim/VictimForm';
import { VICTIM } from 'containers/data-structure';
import validate from 'containers/services/validateForm';
import { validateFormFields } from 'containers/services/validateForm';
import { requestAddVictims } from 'containers/CourtManagerLegalProceedings/actions';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';

export interface VictimDrawerProps {
  intl: IntlShape;
  open: boolean;
  handleToggleDrawer: Function;
  listings: any;
  assignedLawyer: any;
  provisionalClaimId: any;
}

const VictimDrawer: React.FC<VictimDrawerProps> = (props): JSX.Element => {
  const constraints = {
    [VICTIM.FIRST_NAME]: {
      presence: true,
    },
    [VICTIM.LAST_NAME]: {
      presence: true,
    },
  };
  const dispatch = useDispatch();
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);
  const [victim, setVictim] = useState({ [VICTIM.BENEFICIARIES]: [] });
  const [formValidator, setFormValidator] = useState<any>({});
  const handleValidation = () => {
    const validator = validate(victim, constraints);
    setFormValidator(validator);
    if (validateFormFields(validator)) {
      dispatch(
        requestAddVictims(
          {
            victimsCorpoToAdd: [
              { ...victim, provisionalClaimId: props.provisionalClaimId },
            ],
            provisionalClaimId: props.provisionalClaimId,
            isCourtMonitoringManager: false,
            isTrackingActive: featureService.hasFeature(
              FEATURES.TRACKING_ACTIONS_USER,
            ),
          },
          successCallBack,
        ),
      );
    }
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  };

  const successCallBack = () => {
    toast.success(translate(messages.successDialogAddVictims, props));
    props.handleToggleDrawer();
    setVictim({ [VICTIM.BENEFICIARIES]: [] });
    setIsDialogOpen(false);
  };

  return (
    <SahamDrawer
      open={props.open}
      handleToggleDrawer={props.handleToggleDrawer}
      title={translate({ ...messages.addVictim }, props)}
      handleValidateDrawer={handleOpenDialog}
      confirmButtonTitle={'Ajouter'}
      isSaveButtonDisabled={false}
    >
      <ContainerInDrawer>
        <VictimForm
          listings={props.listings}
          victim={victim}
          setVictim={setVictim}
          formValidator={formValidator}
        />
      </ContainerInDrawer>
      <SahamDialog
        handleValidate={handleValidation}
        handleClose={handleCloseDialog as MouseEventHandler}
        title={translate(messages.courtManagerConfirmationDialogTitle, props)}
        cancelTitle={translate(
          messages.courtManagerConfirmationDialogCancel,
          props,
        )}
        confirmTitle={translate(
          messages.courtManagerConfirmationDialogConfirm,
          props,
        )}
        open={isDialogOpen}
      >
        {translate(messages.courtManagerConfirmationDialogContent, props)}
      </SahamDialog>
    </SahamDrawer>
  );
};

export default injectIntl(VictimDrawer);
